import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import s from '../Login/Login.module.scss';
import logo from '../Login/img/logo.svg';
import { ReactComponent as IconCheck } from './img/iconDone.svg';

interface FormData {
  surname: string;
  name: string;
  patronymic: string;
}

interface LocationState {
  phone?: string;
  surname?: string;
  name?: string;
  patronymic?: string;
  fromLogin?: boolean;
}

export const RegistrationStep1: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const stateData = location.state as LocationState;
  const phoneFromState = stateData?.phone;
  const fromLogin = stateData?.fromLogin;

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<FormData>({
    defaultValues: {
      surname: stateData?.surname || '',
      name: stateData?.name || '',
      patronymic: stateData?.patronymic || '',
    },
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const onSubmit = (data: FormData) => {
    navigate('/registration/step2', {
      state: {
        phone: phoneFromState,
        fromLogin,
        ...data,
      },
    });
  };

  const handleBackToLogin = () => {
    if (fromLogin && phoneFromState) {
      navigate('/login', {
        state: {
          restorePhone: phoneFromState,
          showPhoneForm: true,
        },
      });
    } else {
      navigate('/login');
    }
  };

  return (
    <div className={s.enter}>
      <div className={s.inner}>
        <div className={s.logo}>
          <img src={logo} alt='Скилла' />
        </div>

        <h1 className={s.titleStepRegister}>Мои данные</h1>
        <div className={s.stepper}>
          <div className={s.stepperItem}></div>
          <div className={s.stepperItemEmpty}></div>
          <div className={s.stepperItemEmpty}></div>
        </div>

        <div className={s.stepperText}>
          <div className={s.stepperTextItem}>
            <IconCheck />
            <span>ФИО лица по документу удостоверяющему личность</span>
          </div>
          <div className={s.stepperTextItem}>
            <IconCheck />
            <span>Скилла Работа может запросить фотографии документа</span>
          </div>
        </div>

        <form className={s.form} onSubmit={handleSubmit(onSubmit)}>
          <div className={s.inputGroup}>
            <label>Фамилия</label>
            <input
              type='text'
              // required
              placeholder='Иванов'
              className={classNames(s.input, errors?.surname?.message && s.input_error)}
              {...register('surname', {
                required: 'Поле обязательно для заполнения',
                minLength: {
                  value: 2,
                  message: 'Минимум 2 символа',
                },
              })}
            />
            {errors?.surname && (
              <div className={s.errorMessage}>{errors.surname.message}</div>
            )}
          </div>

          <div className={s.inputGroup}>
            <label>Имя</label>
            <input
              type='text'
              placeholder='Иван'
              className={classNames(s.input, errors.name && s.input_error)}
              {...register('name', {
                required: 'Поле обязательно для заполнения',
                minLength: { value: 2, message: 'Минимум 2 символа' },
              })}
            />
            {errors.name && <div className={s.errorMessage}>{errors.name.message}</div>}
          </div>

          <div className={s.inputGroup}>
            <label>Отчество</label>
            <input
              type='text'
              placeholder='Иванович'
              className={classNames(
                s.input,
                errors?.patronymic?.message && s.input_error,
              )}
              {...register('patronymic', {
                minLength: {
                  value: 2,
                  message: 'Минимум 2 символа',
                },
              })}
            />
            {errors?.patronymic?.message && (
              <div className={s.errorMessage}>{errors.patronymic.message}</div>
            )}
          </div>

          <button type='submit' className={s.submitButton}>
            Продолжить
          </button>

          <button type='button' className={s.registerButton} onClick={handleBackToLogin}>
            Начать сначала
          </button>
        </form>

        <div className={s.footer}>
          <span>© {new Date().getFullYear()} go.skilla.ru</span>
        </div>
      </div>
    </div>
  );
};
